import { render, staticRenderFns } from "./MainEnglish.vue?vue&type=template&id=7b47c621&scoped=true&"
import script from "./MainEnglish.vue?vue&type=script&lang=js&"
export * from "./MainEnglish.vue?vue&type=script&lang=js&"
import style0 from "./MainEnglish.vue?vue&type=style&index=0&id=7b47c621&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b47c621",
  null
  
)

export default component.exports